export default "__VITE_ASSET__CbYw0ED0__"